export enum ContinueRegistrationErrorsEnum {
    RegistrationCompleted = 'Birdi is Finalize or not process minimal Register',
    RegistrationPending = 'Continue Registration'
}
